import { useState, useCallback } from "react";

import { Box, Grid, Typography } from "@material-ui/core";

import { Refresh as RefreshIcon } from "@material-ui/icons";

import { Skeleton } from "@material-ui/lab";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import IconButtonLoader from "components/Buttons/IconButtonLoader";
import { columnTextField } from "utils/tables-utils";
import { IsMobile } from "utils/is-mobile";

const getTableColumns = (searching) => [
  columnTextField(
    {
      dataField: "dataFormat",
      text: "Data",
      sort: false,
      formatter: (cell) => (searching ? <Skeleton variant="text" /> : cell),
    },
    false
  ),
  columnTextField(
    {
      dataField: "usuario",
      text: "Usuário",
      formatter: (cell) => (searching ? <Skeleton variant="text" /> : cell),
      align: "center",
      sort: false,
    },
    false
  ),
  columnTextField(
    {
      dataField: "sistema",
      text: "Sistema",
      sort: false,
      formatter: (cell) => (searching ? <Skeleton variant="text" /> : cell),
    },
    false
  ),
  columnTextField(
    {
      dataField: "parametros",
      text: "Parâmetros Enviados",
      sort: false,
      formatter: (cell) => (searching ? <Skeleton variant="text" /> : cell),
    },
    false
  ),
  columnTextField(
    {
      dataField: "mensagem",
      text: "Mensagem",
      sort: false,
      formatter: (cell) => (searching ? <Skeleton variant="text" /> : cell),
    },
    false
  ),
];

export default function TableLogsDeErro({
  dataTable,
  totalRegisters,
  currentPage,
  currentSizePerPage,
  handleSearch,
  searching,
}) {
  const [loading, setLoading] = useState(false);

  const isMobile = IsMobile();

  const doSearch = useCallback(async (page, sizePerPage) => {
    setLoading(true);

    await handleSearch({ page, sizePerPage });

    setLoading(false);
  }, []);

  const handlePageChange = useCallback(
    (page, sizePerPage) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  const handleSizePerPageChange = useCallback(
    (sizePerPage, page) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  return (
    <ToolkitTable
      searched={Boolean(dataTable)}
      keyField="id"
      dataTable={dataTable}
      columnModel={getTableColumns(searching)}
      headerTitle={"Logs de Erro"}
      showSearch={false}
      showPrint
      loading={loading}
      pagination={{
        options: [25, 50, 100],
        defaultOption: currentSizePerPage,
        showTotal: true,
        totalSize: totalRegisters,
        page: currentPage,
        onPageChange: handlePageChange,
        sizePerPage: currentSizePerPage,
        onSizePerPageChange: handleSizePerPageChange,
      }}
      allowEmpty
      noResultTitle="Sua pesquisa não localizou logs de erro cadastrados."
      bootstrapTableProps={{
        remote: true,
        onTableChange: () => {},
      }}
      noResultSubtitle="Verifique os filtros utilizados e tente novamente."
      CustomHeader={() => (
        <Grid
          container
          className="pl-4"
          style={{
            padding: isMobile ? "0" : "0 24px",
            display: "flex",
            alignItems: isMobile ? "flex-start" : "center",
            flexDirection: isMobile ? "column" : "row",
            marginBottom: !isMobile && "1rem",
          }}
        >
          <Grid
            item
            xs={isMobile ? 12 : 6}
            style={{ display: "flex", alignItems: "center" }}
          >
            <Box component={Typography} variant="h3" marginBottom="0!important">
              <Box component="span">Logs de Erro</Box>
              <IconButtonLoader
                size="medium"
                extraStyle={{
                  width: 24,
                  height: 24,
                  marginLeft: "0.3rem",
                }}
                title="Recarregar lista"
                onClick={() =>
                  handleSearch({
                    page: currentPage,
                    sizePerPage: currentSizePerPage,
                  })
                }
                icon={<RefreshIcon color="primary" />}
                aria-label="refresh"
                color="primary"
                disabled={searching}
              />
            </Box>
          </Grid>
        </Grid>
      )}
    />
  );
}
